import HeroComponent from "../../../ui/heroComponent";

const SavingsHeroSection = () => {
  return (
    <HeroComponent heading1="Savings and Account" />
  );
};

export default SavingsHeroSection;
